import React from "react";
import {List} from "../modules/LedgerAccounts";

export function LedgerAccountsListPage() {
  return (
    <List />
  );
}
